@if (visible && currentRoute) {
  <ng-container>
    <div class="container side-menu">
      <div class="row">
        <mat-toolbar>
          <ul class="navbar-list">
            <li class="nav-item close-nav-item">
              <button
                mat-icon-button
                aria-label="Close icon"
                (click)="hideSideMenu()"
              >
                <mat-icon aria-label="Side nav toggle icon" class="close-icon"
                  >close</mat-icon
                >
              </button>
            </li>
          </ul>
        </mat-toolbar>
      </div>
      <div class="row current-page-title">
        <h1>{{ currentRoute.title }}</h1>
      </div>
      <div class="row">
        <ul class="side-menu-page-list">
          @for (page of currentRoute.children; track page) {
            <li
              [ngClass]="
                page.path === currentRoute.path
                  ? 'active-link'
                  : 'inActive-link'
              "
            >
              <a href="javascript:void(0)" (click)="goToRoute(page.path)">{{
                page.title
              }}</a>
            </li>
          }
        </ul>
      </div>
      <mat-divider></mat-divider>
      <div class="row">
        <div class="nav-options">
          <button
            mat-button
            class="location-btn"
            (click)="hideMenuAndShowLocationDialog()"
          >
            <mat-icon class="nav-icon">location_on</mat-icon>
            {{
              translationService.getYouAreViewingFromLocationText(locationName)
            }}
          </button>
          <button
            class="nav-button return-link"
            mat-flat-button
            aria-label="Close icon"
            (click)="hideSideMenu()"
          >
            <mat-icon aria-label="Side nav toggle icon"
              >chevron_left_icon</mat-icon
            >
            {{ translationService.getReturnText() }}
          </button>
          @if (!authService.isLoggedIn()) {
            <button mat-flat-button class="nav-button" (click)="goToLogin()">
              <mat-icon aria-label="Side nav toggle icon"
                >chevron_left_icon</mat-icon
              >
              {{ translationService.getLoginText() }}
            </button>
          } @else {
            <button mat-flat-button class="nav-button" (click)="logout()">
              <mat-icon aria-label="Side nav toggle icon"
                >chevron_left_icon</mat-icon
              >
              {{ translationService.getLogoutText() }}
            </button>
          }
        </div>
      </div>
    </div>
  </ng-container>
}
